// extracted by mini-css-extract-plugin
export default {"logo":"Nav_logo__5kpJ-"};